import { EntityRepository, Repository } from "typeorm";
import { ForkLiftItems } from "../fork-lift-items.entity";

@EntityRepository(ForkLiftItems)
export class ForkLiftItemsRepository extends Repository<ForkLiftItems>{
}